import React from "react";
import { Box, Typography, Container, Button, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Church from "../assets/Church_Front.jpg";

const Home = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 6,
        textAlign: "center",
        backgroundColor: "background.default",
        animation: `${theme.keyframes.fadeIn} 1.5s`,
      }}
    >
      <Container>
        <Grid2 container spacing={4} alignItems="center" justifyContent="center">
          {/* Text Content Section */}
          <Grid2 xs={12} md={6}>
            <Typography
              variant="h1"
              sx={{
                animation: `${theme.keyframes.slideIn} 2s ease`,
              }}
            >
              Welcome to Praise Revival Church
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 3,
                animation: `${theme.keyframes.fadeInUp} 2.5s`,
              }}
            >
              Building faith, community, and hope in Dharmapuri. Join us for
              worship, fellowship, and spiritual growth.
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              component={Link}
              to="/about"
              sx={{
                mt: 4,
                animation: `${theme.keyframes.pulse} 2s infinite`,
              }}
            >
              Learn More
            </Button>
          </Grid2>

          {/* Image Section */}
          <Grid2 xs={12} md={6}>
            <Box
              component="img"
              src={Church}
              alt="Church Image"
              sx={{
                width: "100%",
                borderRadius: 2,
                boxShadow: 3,
                animation: `${theme.keyframes.zoomIn} 2s`,
              }}
            />
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};

export default Home;
